import React from 'react';
import CenteredSpinner from '../../../libs/react-components-admin/spinners/centered-spinner';
import {orgId, defaultErrorHandler} from '../../../context/context';
import formService from '../../../services/form-service';
import OpenInNewLink from '../../../libs/react-components-admin/link/open-in-new-link';

export default class TailorYourForm extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      forms: null,
    };
  }

  componentDidMount() {
    formService.findAllFormsCreatingDefaultIfEmpty()
      .then(forms => this.setState({forms: forms}))
      .catch(defaultErrorHandler);
  }

  link() {
    if (this.state.forms.length === 1) {
      return `/forms/${encodeURIComponent(this.state.forms[0].id)}?shop=${encodeURIComponent(orgId)}`;
    } else {
      return `/forms?shop=${encodeURIComponent(orgId)}`;
    }
  }

  render() {
    if (!this.state.forms) {
      return <CenteredSpinner/>;
    }
    return <>
      Tailor <OpenInNewLink href={this.link()}>your form</OpenInNewLink> to suit your needs.
    </>
  }

}
